module.exports = __webpack_public_path__ + "media/images/app-store-deadbe9a7595ff8a5639fedc15a7d455.png";